// Solo se acepta tarjeta (PayPal y Bizum retirados el 2026-10-21).
export const MARKS = {
  visa: <span className="font-black italic tracking-tight text-[#1A1F71]">VISA</span>,
  mastercard: (
    <span className="flex -space-x-1.5" aria-label="Mastercard">
      <span className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" />
      <span className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] opacity-90" />
    </span>
  ),
};

const chip = "inline-flex items-center justify-center h-7 min-w-[52px] px-2 rounded-md bg-white border border-slate-200 text-xs";

export const PayMethodBadges = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`} data-testid="pay-method-badges">
    {Object.entries(MARKS).map(([k, m]) => <span key={k} className={chip} data-testid={`pay-badge-${k}`}>{m}</span>)}
  </div>
);

export const METODOS = {
  tarjeta: { mark: <span className="flex items-center gap-1.5">{MARKS.visa}{MARKS.mastercard}</span>, sub: "Tarjeta",
    hint: "Visa, Mastercard y otras tarjetas. Renovación automática, cancela cuando quieras.", cta: "Suscribirme con tarjeta" },
};

export function PayMethodPicker() {
  return (
    <div className="mb-4" data-testid="pay-method-picker">
      <p className="text-sm font-medium text-slate-700 mb-1.5">Método de pago</p>
      <div className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2.5" data-testid="pay-method-tarjeta">
        <span className="h-5 flex items-center text-sm">{METODOS.tarjeta.mark}</span>
        <span className="text-xs text-slate-600">{METODOS.tarjeta.sub}</span>
      </div>
      <p className="text-xs text-slate-500 mt-2" data-testid="pay-method-hint">{METODOS.tarjeta.hint}</p>
    </div>
  );
}
